import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import suiviFacturesAvantEcheance, { SuiviFacturesAvantEcheanceState } from './modules/SuiviFacturesAvantEcheance';
import { state as suiviFacturesAvantEcheanceState } from './modules/SuiviFacturesAvantEcheance/state';
import suiviFacturesEnRetard, { SuiviFacturesEnRetardState } from './modules/SuiviFacturesEnRetard';
import { state as suiviFacturesEnRetardState } from './modules/SuiviFacturesEnRetard/state';
import { mutations } from './mutations';
import { SuiviFacturesState } from './state';
import suiviFinancier, { SuiviFinancierState } from '@/modules/SuiviFactures/store/modules/SuiviFinancier';
import { state as suiviFinancierState } from './modules/SuiviFinancier/state';
import suiviFacturesPayees, {
    SuiviFacturesPayeesState
} from '@/modules/SuiviFactures/store/modules/SuiviFacturesPayees';
import { state as suiviFacturesPayeesState } from './modules/SuiviFacturesPayees/state';

export interface SuiviFacturesModuleState extends SuiviFacturesState {
    suiviFacturesEnRetardState: SuiviFacturesEnRetardState;
    suiviFacturesAvantEcheanceState: SuiviFacturesAvantEcheanceState;
    suiviFinancierState: SuiviFinancierState;
    suiviFacturesPayeesState: SuiviFacturesPayeesState;
}

const state: SuiviFacturesModuleState = {
    suiviFacturesEnRetardState,
    suiviFacturesAvantEcheanceState,
    suiviFinancierState,
    suiviFacturesPayeesState,
};

const module: Module<SuiviFacturesModuleState, RootState> = {
    namespaced: true,
    modules: {
        suiviFacturesEnRetard: suiviFacturesEnRetard,
        suiviFacturesAvantEcheance: suiviFacturesAvantEcheance,
        suiviFinancier: suiviFinancier,
        suiviFacturesPayees: suiviFacturesPayees
    },
    state,
    mutations,
};

export default module;
export type { SuiviFacturesState };
